import React from 'react';
import useSheet from 'app/jss';
import classNames from 'classnames';
import Icon from 'app/components/commons/Icon';

type Props = {
  classes: Object,
  icon: string,
  className?: string,
  border?: boolean,
  size?: string,
  position?: 'BOTTOMLEFT' | 'TOPLEFT' | 'BOTTOMRIGHT' | 'TOPRIGHT',
};

type State = {};


class IconWatermark extends React.Component {
  props: Props;
  state: State = {};

  static defaultProps = {
    className: undefined,
    size: undefined,
    border: false,
    position: 'BOTTOMLEFT',
  };

  render() {
    const {
      classes,
      icon,
      size,
      className,
      position,
      border,
    } = this.props;

    const style = {};
    if (size) {
      style.paddingBottom = size;
      style.width = size;
    }

    return (
      <div className={classes.container}>
        <div
          className={classNames(classes.watermark, className, position.toLowerCase(), {
            border,
          })}
          style={style}
        >
          <Icon type={icon} className={classes.icon} size="100%" />
        </div>
      </div>
    );
  }
}

function applyStyles(theme: Theme) {
  return {
    container: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      pointerEvents: 'none',
    },
    watermark: {
      position: 'absolute',
      overflow: 'hidden',
      pointerEvents: 'none',
      zIndex: 0,
      '&.bottomleft': {
        bottom: 0,
        left: 0,
      },
      '&.bottomright': {
        bottom: 0,
        right: 0,
      },
      '&.topleft': {
        top: 0,
        left: 0,
      },
      '&.topright': {
        top: 0,
        right: 0,
      },
      '&.border': {
        border: `1em solid ${theme.color.basis6}`,
        borderRadius: '100%',
      },
    },
    icon: {
      position: 'absolute',
    },
  };
}

export default useSheet(applyStyles)(IconWatermark);
